import { ToggleSwitch } from "@bokio/designsystem/components/ToggleSwitch/ToggleSwitch";
import { mergeClassNames } from "@bokio/utils/classes";

import type { ReactNode } from "react";

import * as styles from "./toggleListItem.scss";

interface ToggleListItemProps {
	className?: string;
	title: string;
	checked: boolean;
	onChange: (newValue: boolean) => void;
	content: ReactNode;
	disabled?: boolean;
	testId?: string;
}

export const ToggleListItem = (props: ToggleListItemProps) => (
	<div className={mergeClassNames(styles.wrapper, props.className)}>
		<div className={styles.titleRow}>
			<h3>{props.title}</h3>
			<ToggleSwitch disabled={props.disabled} checked={props.checked} onChange={props.onChange} testId={props.testId} />
		</div>
		<div>{props.content}</div>
	</div>
);
